import URI from 'urijs'
import Prism from 'prismjs'
import Common from './lib/Common'
import * as bootstrap from 'bootstrap'
import { detect } from 'detect-browser'
import { addPlatformTabs } from './lib/Common'
import TocController from './lib/TocController'
import HelpController from './lib/HelpController'
import SearchController from './lib/SearchController'
import '@simonsoft/cds-components/lib/components/language-picker';

try {
  addPlatformTabs();
} catch (e) {
  console.log(`Failed to add profiling controls: ${e}`);
}
try {
  Prism.highlightAll();
} catch (e) {
  console.log(`Failed to add syntax highlighting: ${e}`);
}

var common = null;
const indexAttr = $('link[rel=index]').attr('href');
if (indexAttr && window.history) {
  const index = URI(indexAttr).absoluteTo(window.location.href).href();
  common = Common(index);
  if (common.isOffline()) {
    const $toc = $('nav[role=toc]');
    TocController($toc, index, true);
    SearchController($toc, index, true);
    HelpController();
  } else {
    $.ajax({
      url: index,
      success: (data) => {
        const $toc = $('<body>').append($.parseHTML(data)).find('nav');
        TocController($toc, index);
        SearchController($toc, index);
        HelpController();
      },
    })
  }
}

/**************************************************************************************************/
/*                                    Simonsoft Customizations                                    */
/************************************************************************************************ */

// Detect the user's browser
const browser = detect();
if (browser) {
  let $html = $('html');
  $html.addClass(browser.name);
}

// Scroll element into the view
$.fn.scrollTo = function (speed) {
  if (typeof(speed) === 'undefined') speed = 1000;

  $('html, body').animate({
      scrollTop: parseInt($(this).offset().top)
  }, speed);
};

function initializeRelatedLinks() {
  // Override the click events of the anchor links and make the whole family links buttons clickable
  // Furthermore, just like the TOC items, load the content using an Ajax call without a browser redirect
  $('.related-links .familylinks div').each(function() {
    const $a = $(this).children('a[href]').filter(common.isLinkLocal);
    if ($a) {
      $a.off("click");
      $a.on("click", {href: $a.attr('href')}, navigateHandler);
      $(this).on("click", {href: $a.attr('href')}, navigateHandler);
    }
  })
  // Do the same for child links
  $('.related-links .olchildlinks li').each(function() {
    const $a = $(this).children('a[href]').filter(common.isLinkLocal)
    if ($a) {
      $a.off("click");
      $a.on("click", {href: $a.attr('href')}, navigateHandler);
      $(this).on("click", {href: $a.attr('href')}, navigateHandler);
    }
  })

  function navigateHandler(event) {
    event.preventDefault();
    event.stopPropagation();

    const destination = event.data.href;
    const origin = common.isOffline() ? "" : window.origin;
    const href = origin + window.location.pathname.split('/').slice(0, -1).join('/') + '/' + destination;
    common.loadMain(href);
  }
}

if (common.isOffline()) {
  $(document).ready(function () {
    initializeRelatedLinks();
  })
} else {
  $(document).bind('ajaxComplete', function (event) {
    initializeRelatedLinks();
    // Make the sidebar which contains the table of contents collapsible on mobile devices
    if ($('#navbar-toggler').attr('aria-expanded') === "true") {
      $('#navbar-toggler').click();
      $('.navbar').scrollTo(1000);
    }
  })
}

$('.sidebar-toc').addClass('collapsible collapse');

$('.navbar-brand').on('shown.bs.collapse', function () {
  $('.navbar-brand').addClass('shown');
})

$('.navbar-brand').on('hidden.bs.collapse', function () {
  $('.navbar-brand').removeClass('shown');
})

$('.navbar-search').on('shown.bs.collapse', function () {
  $('.navbar-search').addClass('shown');
})

$('.navbar-search').on('hidden.bs.collapse', function () {
  $('.navbar-search').removeClass('shown');
})

$('.sidebar-toc').on('shown.bs.collapse', function () {
  $('.sidebar-toc').addClass('shown');
})

$('.sidebar-toc').on('hidden.bs.collapse', function () {
  $('.sidebar-toc').removeClass('shown');
})
